import { render, staticRenderFns } from "./QuotesManager.vue?vue&type=template&id=c2069df6"
import script from "./QuotesManager.vue?vue&type=script&lang=js"
export * from "./QuotesManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports